
import english from './english';


export {
    english,
    english as EN,
    english as default,
};
